import { TransactionListItem } from "@common/schemas/transaction.schema";
import { Tag } from "@design-system/Tag/Tag";
import { TransactionCategory } from "@components/transactions/TransactionCategory";
import { RefValue } from "@common/types/auditLog";
import { Category } from "@common/types/category";
import { DeletedCategory } from "./DeletedCategory";
import styles from "./HistoryCategory.module.scss";

interface HistoryCategoryProps {
    value: RefValue;
    field: string;
    resource?: Record<string, unknown>;
    categories: Record<string, Category>;
}

export const HistoryCategory = ({
    value,
    field,
    resource,
    categories,
}: HistoryCategoryProps) => {
    if (!field || field !== "categoryId" || typeof value.value !== "string") {
        return null;
    }

    const category = categories[value.value];

    if (category) {
        return (
            <TransactionCategory
                transaction={
                    {
                        ...resource,
                        categoryId: value.value,
                        category,
                    } as unknown as TransactionListItem
                }
            />
        );
    }

    return (
        <div className={styles.deletedContainer}>
            <DeletedCategory label={value.valueLabel ?? ""} />
            <Tag color="neutral" outline>
                Deleted
            </Tag>
        </div>
    );
};
